// extracted by mini-css-extract-plugin
export var alertIcon = "_pl-0";